// Centralised delivery / courier mode definitions.
// Used by Register Member, Register Advertiser, Scan Dispatch, Print Labels,
// Dispatch Reports — any place courier type appears.

// The ONLY 6 options allowed system-wide. Stored value === displayed value
// (full name) for new entries. Legacy single-letter codes are still mapped
// to a display name via DELIVERY_LABEL for backward compatibility.
export const DELIVERY_OPTIONS = [
  { value: 'Trackon', label: 'Trackon' },
  { value: 'DTDC', label: 'DTDC' },
  { value: 'Registered Post', label: 'Registered Post' },
  { value: 'By Hand', label: 'By Hand' },
  { value: 'By Post', label: 'By Post' },
  { value: 'E-Magazine', label: 'E-Magazine' },
];

// Mapping of legacy / short codes → canonical full name.
// Used at display time so old DB records (D, T, RP, BH, BP, EMAGZE…) still
// render correctly even before migration completes.
export const LEGACY_TO_FULL = {
  'D': 'DTDC',
  'd': 'DTDC',
  'DTDC': 'DTDC',
  'T': 'Trackon',
  't': 'Trackon',
  'TRACKON': 'Trackon',
  'Trackon': 'Trackon',
  'R': 'Registered Post',
  'RP': 'Registered Post',
  'RR': 'Registered Post',
  'Registered Post': 'Registered Post',
  'Registered': 'Registered Post',
  'BH': 'By Hand',
  'By Hand': 'By Hand',
  'BP': 'By Post',
  'By Post': 'By Post',
  'EMAGZE': 'E-Magazine',
  'EMAG': 'E-Magazine',
  'E-Magazine': 'E-Magazine',
  'E-Mag': 'E-Magazine',
};

/** Convert any stored courier value (legacy or new) to its full display name. */
export function deliveryLabel(value) {
  if (!value) return '';
  const key = String(value).trim();
  return LEGACY_TO_FULL[key] || key;
}

/** Returns true when the courier option is a hand/post one (no docket). */
export function isNoDocketMode(value) {
  const full = deliveryLabel(value);
  return full === 'By Hand' || full === 'By Post' || full === 'E-Magazine';
}
